import { cruiseResponseEntity } from "../../Data/Connections/Cruise"
import type { DataStore } from "../../Data/Store"
import type { IAppResponse, ICruiseResponse } from "../../Types"
import { CruiseApi } from "../../Types/Generated/LogbookApi/CruiseApi"
import type { ICruiseUpdateRequest } from "../../Types/Generated/LogbookApi/CruiseApi"

export interface CruiseWriterIds {
  shipId: number;
  cruiseId: number;
}

export interface CruiseWriters {
  updateCruise: (values: ICruiseUpdateRequest) => Promise<ICruiseResponse>;
  calculateCruise: () => Promise<IAppResponse>;
}

export function createStoreCruiseWriters(store: DataStore, ids: CruiseWriterIds): CruiseWriters {
  return {
    updateCruise: (values) => {
      const current = store.getEntity("Cruise", ids.cruiseId);
      const optimistic = current ? { ...current, ...values } : undefined;
      return store.mutate({
        optimistic: optimistic ? { upsert: { Cruise: [optimistic] } } : undefined,
        request: (client) => new CruiseApi(client).cruises.update({ params: ids, body: values }).call(),
        reconcile: (response) => {
          const latest = store.getEntity("Cruise", ids.cruiseId);
          return {
            entities: {
              Cruise: optimistic && latest !== optimistic
                ? []
                : [cruiseResponseEntity(response, latest)],
            },
          };
        },
      });
    },
    calculateCruise: () => store.mutate({
      request: (client) => new CruiseApi(client).cruises.calculate({ params: ids }).call(),
    }),
  };
}

const rejectNoop = (name: string) => (): Promise<never> =>
  Promise.reject(new Error(`noopCruiseWriters.${name}: no writer provided (read-only Cruise context)`));

export const noopCruiseWriters: CruiseWriters = {
  updateCruise: rejectNoop("updateCruise"),
  calculateCruise: rejectNoop("calculateCruise"),
};
